var map = {
	"./1125-joy-joy.png": "2a70",
	"./1125-joy-kirakira.png": "eea1",
	"./1125-joy-manpuku.png": "5b0f",
	"./1125-joy-normal.png": "866d",
	"./1125-joy-thinking.png": "e6f6",
	"./1125-joy-yeah.png": "9556"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cedc";